import React, { useState, useEffect } from 'react';
import { SpotlightCard } from '@atlaskit/onboarding';
import { Link } from 'react-router-dom';

import { useLocalStorage } from '@/controllers';
import { popup } from '@/styles';

// Low traffic survey status. For now, let's just keep it static in FrontEnd, so
// this should be changed each time we launch a new survey
const SURVEY_STATUS_ACTIONED: string = 'actioned_low-traffic';
const SURVEY_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSdbTWh6k_g3X27eKBbqxH7ttT2kDSqDTqtlrNOE6xpVx_NoWA/viewform?usp=sf_link';
const SURVEY_TEXT = `Please participate in a short survey to provide some feedback on your experience with SLOs that receive a low volume of events. Thank you!`;

const Survey: React.FC = () => {
  const [surveyVisible, setSurveyVisible] = useState(false);
  const [surveyStatus, setSurveyStatus] = useLocalStorage('tome-survey', '');

  const handleRemove = () => {
    setSurveyStatus(SURVEY_STATUS_ACTIONED);
    setSurveyVisible(false);
  };

  useEffect(() => {
    if (surveyStatus !== SURVEY_STATUS_ACTIONED) setSurveyVisible(true);

    // show survey only once hence set status to actioned here
    setSurveyStatus(SURVEY_STATUS_ACTIONED);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!surveyVisible) return <></>;

  return (
    <div css={popup}>
      <SpotlightCard
        actions={[
          {
            text: (
              <Link target="_blank" to={SURVEY_URL}>
                Open Survey
              </Link>
            ),
            onClick: handleRemove,
          },
          {
            text: 'Dismiss',
            onClick: handleRemove,
            appearance: 'subtle',
          },
        ]}
      >
        {SURVEY_TEXT}
      </SpotlightCard>
    </div>
  );
};

export default Survey;
